
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/technology",
      function () {
        return require("private-next-pages/technology.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/technology"])
      });
    }
  